import React from 'react';
import ReactDOM from 'react-dom';
import Card from './Card';

ReactDOM.render(
  <React.StrictMode>
    <Card />
  </React.StrictMode>,
  document.getElementById('root')
);

